import { Component, OnInit } from '@angular/core';
import { ChkService } from '../service/chk.service';
import { AuthService } from 'app/service/auth.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
declare var $ : any;

@Component({
  selector: 'angly-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  /* Variables */
  homeContent    : any;
  services       : any;
  servicesUs :any;
  projectGallary : any;
  posts          : any;
  team           : any;
  pricingContent : any;
  contact        : any;
  videoContent   : any;
  mobileFeatured : any;
  testimonial    : any;

  baseURL = environment.baseURL


  selectedFile: File | null = null;

onFileSelected(event: any) {
  this.selectedFile = event.target.files[0] as File;
}

uploadFile() {
   if (this.selectedFile) {
     // Aquí puedes agregar la lógica para subir el archivo al servidor
     // por ejemplo, utilizando una solicitud HTTP
     // Puedes usar HttpClient de Angular para esto.
     // Aquí hay un ejemplo básico:
     
     const formData = new FormData();
     formData.append('file', this.selectedFile);
     
     // Realizar la solicitud HTTP utilizando HttpClient
     // this.http.post('url_del_servidor', formData).subscribe(response => {
     //   // Manejar la respuesta del servidor
     // });
     
     // Una vez que el archivo se ha subido con éxito,
     // puedes realizar las acciones necesarias, como mostrar un mensaje de éxito o reiniciar el input.
     
     // Reiniciar el input de archivo
     this.selectedFile = null;
   }
 }

  constructor( private service:ChkService, private auth: AuthService ,
   private router: Router
   ) {

      this.service.getHomeContent().
         subscribe(response => {this.homeContent = response},
                   err      => console.log(err),
                   ()       => this.getContent(this.homeContent)
               );

      this.service.getServices().
         subscribe(response => {this.services = response},
                  err       => console.log(err),
                  ()        =>this.services
               );
      this.service.getServicesUs().
         subscribe(response => {this.servicesUs = response},
                  err       => console.log(err),
                  ()        =>this.servicesUs
                 );              

      this.service.getPosts().
         subscribe(response => {this.posts = response},
                  err      => console.log(err),
                  ()       => this.posts
               );

      this.service.getProjectGallary().
         subscribe(response => {this.projectGallary = response},
                   err      => console.log(err),
                   ()       => this.projectGallary
               );


      this.service.getTeam().
         subscribe(response => {this.team = response},
                   err      => console.log(err),
                   ()       => this.team
               );

      this.service.getPricingPageContent().
         subscribe(response => {this.pricingContent = response},
                  err       => console.log(err),
                  ()        => this.pricingContent
               );

      this.service.getContactContent().
         subscribe(response => {this.contact = response},
                   err      => console.log(err),
                   ()       => this.contact
               );

      this.service.getHomeTestimonial().
         subscribe(response => {this.testimonial = response},
                   err      => console.log(err),
                   ()       => this.testimonial
               );
      }

  ngOnInit() {
  }

  resetAuth(){
   this.auth.setAuth('');

   this.router.navigate(['/login']);
  }

  /*
   * getContent is used for get the home page content.
   * Used variables is videoContent and mobileFeatured.
   */
   getContent(content)
   {
      this.videoContent    = content.video_content;
      this.mobileFeatured  = content.mobile_featured;
   }

   subscribeFormClasses : any = {rowClass:"row", fieldClass:"col-sm-12 col-md-6"}

   navigateTo(url: string, queryParams) {
      this.router.navigate([url], { queryParams: queryParams });
    }
  

}
